import { SVGProps, memo } from 'react'

function AppStoreLinkSvg({ color, ...rest }: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7153 9.87751C11.5486 10.0575 11.4523 10.3324 11.4523 10.6923V23.4566C11.4523 23.8164 11.5486 24.0914 11.7211 24.2641L11.7657 24.303L18.907 17.1515V16.9918L11.76 9.83868L11.7153 9.87751Z"
        fill="url(#paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2832 19.543L18.9013 17.1578V16.9908L21.2832 14.6055L21.335 14.6372L24.1524 16.2408C24.9588 16.6957 24.9588 17.4471 24.1524 17.9077L21.335 19.5115L21.2832 19.543Z"
        fill="url(#paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3349 19.511L18.9013 17.0737L11.7153 24.2699C11.9784 24.552 12.4197 24.5837 12.9127 24.3087L21.3349 19.511Z"
        fill="url(#paint2_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3353 14.6366L12.9132 9.84591C12.4201 9.56391 11.9773 9.60258 11.7158 9.88474L18.9017 17.0738L21.3353 14.6366Z"
        fill="url(#paint3_linear)"
      />
      <path
        opacity="0.25"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9128 9.92974L24.1524 16.3241C24.5176 16.53 24.7231 16.7991 24.7547 17.0741C24.7547 16.7732 24.5563 16.4709 24.1524 16.2406L12.9128 9.84622C12.1064 9.3842 11.4523 9.77 11.4523 10.6927V10.7762C11.4523 9.85216 12.1064 9.47342 12.9128 9.92974Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6525 10.0723V3.73288C15.6533 3.30823 15.5705 2.88758 15.4086 2.49509C15.2467 2.10259 15.009 1.74597 14.7092 1.44569C14.4093 1.14542 14.0532 0.907385 13.6613 0.745272C13.2693 0.583151 12.8492 0.500134 12.4252 0.500983H3.98455C3.5605 0.500134 3.14045 0.583151 2.74851 0.745272C2.35657 0.907385 2.00046 1.14542 1.70061 1.44569C1.40076 1.74597 1.16307 2.10259 1.00118 2.49509C0.839294 2.88758 0.756392 3.30823 0.757239 3.73288V12.1855C0.756392 12.6102 0.839294 13.0309 1.00118 13.4234C1.16307 13.8158 1.40076 14.1725 1.70061 14.4727C2.00046 14.7731 2.35657 15.0111 2.74851 15.1732C3.14045 15.3353 3.5605 15.4183 3.98455 15.4174H10.3274V10.6637C10.3274 10.5915 10.33 10.5186 10.3353 10.4456H7.3475V10.4455H3.55012C3.36905 10.4455 3.19541 10.3734 3.06737 10.2452C2.93934 10.117 2.86742 9.94311 2.86742 9.76174C2.86742 9.58045 2.93934 9.40659 3.06737 9.27832C3.19541 9.15012 3.36905 9.0781 3.55012 9.0781H5.24883L7.46174 5.24052L6.80225 4.10594C6.75973 4.03248 6.73208 3.95134 6.72089 3.86716C6.70971 3.78299 6.71521 3.69744 6.73707 3.61539C6.75893 3.53335 6.79673 3.45642 6.8483 3.38902C6.89987 3.32162 6.96421 3.26506 7.03763 3.22257C7.11105 3.18009 7.19212 3.15252 7.27618 3.14144C7.36025 3.13037 7.44568 3.13599 7.52759 3.158C7.60948 3.18001 7.6862 3.21797 7.75347 3.26972C7.82066 3.32146 7.87706 3.38597 7.91943 3.45956L8.20411 3.95308L8.45316 3.52121C8.54368 3.36461 8.69262 3.25044 8.8672 3.20382C9.04179 3.1572 9.22778 3.18194 9.38414 3.2726C9.5405 3.36326 9.65449 3.51241 9.70106 3.68725C9.74763 3.86209 9.72289 4.04828 9.63237 4.20488L6.82491 9.0781H8.73866C8.74444 9.0781 8.75029 9.0781 8.75614 9.07818H9.60874L9.40896 8.73009C9.33224 8.58672 9.264 8.45597 9.20415 8.34144V8.34137H9.20408L9.204 8.34121L9.20393 8.34106C9.11858 8.17765 9.05034 8.04705 8.99934 7.9594C8.79536 7.61131 8.70927 7.20656 8.75404 6.80551C8.79873 6.40446 8.9719 6.02868 9.24757 5.73433L11.0774 8.90913C11.7252 8.37494 12.5535 8.40858 13.2108 8.70005C13.3011 8.73992 13.3896 8.78483 13.476 8.83425L13.4773 8.83493L15.6525 10.0723ZM4.97761 12.2846L5.63549 11.1286C5.54822 10.9764 5.42125 10.8509 5.26818 10.7655C5.11511 10.6802 4.94172 10.6381 4.76659 10.6438C4.59869 10.6425 4.43283 10.6808 4.2825 10.7557L3.7984 11.601C3.75357 11.6785 3.72444 11.7642 3.71265 11.8529C3.70087 11.9418 3.70667 12.032 3.72972 12.1186C3.75277 12.2051 3.79262 12.2863 3.84701 12.3575C3.90139 12.4286 3.96923 12.4884 4.04666 12.5333C4.12408 12.5782 4.20958 12.6073 4.29827 12.6191C4.38696 12.6309 4.4771 12.6251 4.56355 12.6021C4.64999 12.5789 4.73105 12.539 4.8021 12.4846C4.87314 12.4301 4.93278 12.3622 4.97761 12.2846Z"
        fill="url(#paint4_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="18.2658"
          y1="10.5536"
          x2="6.82437"
          y2="13.5987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.01" stopColor="#00A1FF" />
          <stop offset="0.26" stopColor="#00BEFF" />
          <stop offset="0.51" stopColor="#00D2FF" />
          <stop offset="0.76" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="25.4722"
          y1="17.0747"
          x2="11.517"
          y2="17.0747"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.41" stopColor="#FFBD00" />
          <stop offset="0.78" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="20.0117"
          y1="18.3116"
          x2="10.8061"
          y2="33.7809"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="9.9054"
          y1="5.68588"
          x2="14.0119"
          y2="12.5941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.07" stopColor="#2DA771" />
          <stop offset="0.48" stopColor="#15CF74" />
          <stop offset="0.8" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="7.09025"
          y1="13.0537"
          x2="7.09025"
          y2="0.500983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D6FF2" />
          <stop offset="1" stopColor="#1AC8FC" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const AppStoreLinkIcon = memo(AppStoreLinkSvg)
